import React from 'react';
import '../../App.css';
import Nizam1 from '../../Assets/Branches/banglore/Nizam1.jpeg';
import Nizam2 from '../../Assets/Branches/banglore/Nizam2.jpeg';
import Nizam3 from '../../Assets/Branches/banglore/Nizam3.jpeg';
import Nizam4 from '../../Assets/Branches/banglore/Nizam4.jpeg';
import Nizam5 from '../../Assets/Branches/banglore/Nizam5.jpeg';
import Nizam6 from '../../Assets/Branches/banglore/Nizam6.jpeg';
import Nizam7 from '../../Assets/Branches/banglore/Nizam7.jpeg';
import Nizam8 from '../../Assets/Branches/banglore/Nizam8.jpeg';
import LocationOnOutlinedIcon from '@mui/icons-material/LocationOnOutlined';
import MailOutlinedIcon from '@mui/icons-material/MailOutlined';
import CallOutlinedIcon from '@mui/icons-material/CallOutlined';

export default function Nizamabad() {
  return <div id="branchScreen">
  <h2 className='branchTitle'>Nizamabad Campus</h2>
  <div className="branch-slide-track">
      <img src={Nizam1} alt=" bngBarCounter"/>
      <img src= {Nizam2}  alt="bngClassRoom"/>
      <img src= {Nizam3}  alt="bngOffice"/>
      <img src={Nizam4} alt="bngBar"/>
      <img src= {Nizam5}  alt="bngClass"/>
      <img src={Nizam6} alt=" bngFlair"/>
      <img src= {Nizam7}  alt="bngFlair1"/>
      <img src={Nizam8} alt=" bngBarCounter"/>
      <img src= {Nizam1}  alt="bngClassRoom"/>
      <img src= {Nizam4}  alt="bngOffice"/>
      <img src={Nizam3} alt="bngBar"/>
  </div>
  <div className='BranchContactScreen'>
        <h1>Contact Us</h1>
        <div className='BranchDiv'>
            <h3>UNIVERSAL BARTENDING ACADEMY NIZAMABAD</h3>
            <div className="BranchlocationAddress">
                <p className="BranchlocationIcon"><LocationOnOutlinedIcon/></p>
                <p className="BranchlocationAdr">6-2-129, laxmi nivas,2nd floor,zp road, Subhash nagar, Nizamabad-503002</p>
            </div>
            <div className="Branchlocation_Email">
                <p className="BranchlocationIcon"><MailOutlinedIcon/></p>
                <p className="BranchlocationEmail">ubanzb@gmail.com</p>
            </div>
            <div className="BranchBranchlocation_Phone">
                <p className="BranchlocationIcon"><CallOutlinedIcon/></p>
                <p className="BranchlocationEmail">+91 8179280385 /+91 8179280386</p>
            </div>
        </div>
        <div className='BranchembeddedMap'>
            <iframe className='BranchubaMap' title="location" src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3779.562808911271!2d78.1113924!3d18.6836046!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bcdc5cad13d9f4d%3A0x6648334a53bfd90b!2sUniversal%20Bartending%20Academy%20Nizamabad!5e0!3m2!1sen!2sin!4v1772381890455!5m2!1sen!2sin"></iframe>
        </div>
    </div>
</div>
}

